import { cp } from "../config";
import { getRequest } from "../helpers/networkHelper";

let previousPath: string | null = null;
let currentPath: string | null = null;

/**
 * Records a pathname change so subsequent touchpoint calls can report an
 * accurate in-app referrer. `document.referrer` only reflects the initial
 * entry page and never updates across SPA navigations.
 */
export const recordRouteChange = (newPath: string): void => {
    if (currentPath === newPath) return;
    if (currentPath !== null) previousPath = currentPath;
    currentPath = newPath;
};

const resolveReferrer = (): string =>
    previousPath !== null ? `${window.location.origin}${previousPath}` : document.referrer;

/**
 * Fires a marketing attribution signal to the backend — intentionally bypasses
 * the analytics consent check because it's a server-side signal, not browser
 * analytics. Browser automatically forwards Cookie and User-Agent
 * (openCMSAxios is configured with withCredentials: true). The `referrer`
 * param is forwarded by the proxy as the Referer header to Phase6.
 *
 * All current URL params are forwarded (matches the teacher-area behaviour).
 * For Cornelsen flows, call this from AuthWrapper before login so UTMs are
 * still present in the URL.
 */
export const trackTouchpointPageView = (page: string): void => {
    if (cp.cfg.ENVIRONMENT !== "prod") return;

    const currentParams: Record<string, string> = {};
    new URLSearchParams(window.location.search).forEach((value, key) => {
        currentParams[key] = value;
    });

    getRequest("aea/touchpoint/page-viewed/", {
        ...currentParams,
        page,
        referrer: resolveReferrer(),
    }).catch(() => {});
};
